import DocumentEvent from "../events/DocumentEvent";

// SlideStockの資料ダウンロード
export const GetSlideStockDocument = (id: number, fileName: string) =>
    ({
        type: DocumentEvent.GetSlideStockDocumentStarted,
        id,
        fileName,
    } as const);

export const GetSlideStockDocumentCompleted = (url: string) =>
    ({
        type: DocumentEvent.GetSlideStockDocumentCompleted,
        url,
    } as const);

// 動画の資料ダウンロード
export const GetVideoDocument = (id: number, fileName: string) =>
    ({
        type: DocumentEvent.GetVideoDocumentStarted,
        id,
        fileName,
    } as const);

export const GetVideoDocumentCompleted = (url: string) =>
    ({
        type: DocumentEvent.GetVideoDocumentCompleted,
        url,
    } as const);

// ダウンロードリンクをクリアする。
export const ResetDocumentUrl = () =>
    ({
        type: DocumentEvent.ResetDocumentUrl,
    } as const);
